import {Modal} from "@ui";
import PropTypes from "prop-types";
import "../../styles/global.css";

const BaseModal = ({
  children,
  title,
  state,
  closeModal,
  width = 520,
  className,
  wrapClassName,
  closable = true,
  destroyOnClose = false,
}) => {
  return (
    <Modal
      title={title}
      open={state}
      onOk={closeModal}
      onCancel={closeModal}
      footer={false}
      centered
      width={width}
      className={className}
      closable={closable}
      destroyOnClose={destroyOnClose}
      styles={{
        body: {fontFamily: "var(--font-family)"},
        mask: {
          background: "rgba(0, 0, 0, 0.65)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
        },
      }}
      wrapClassName={wrapClassName}
    >
      {children}
    </Modal>
  );
};

BaseModal.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
  state: PropTypes.bool,
  closeModal: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  wrapClassName: PropTypes.string,
  closable: PropTypes.bool,
  destroyOnClose: PropTypes.bool,
};

export default BaseModal;
